import React, { Component } from 'react'

import './styles/style.css'

class Loader extends Component {

    render() {

        return (
            <div className="LoaderWrapper">
                <div className="LoaderContentWrapper">
                    <div className="LoaderContent">
                        <div className="LoaderLogo"></div>
                        <div className="LoaderName">ANHIL MARIN</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Loader


// WEBPACK FOOTER //
// ./src/Components/Loader/index.js